export default "__VITE_ASSET__33c2a407__"